import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {isMobile} from "react-device-detect"
//import {Helmet  } from 'react-helmet-async'
import {Links} from '../routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'
import Input from '../components/ui/input.jsx';
import {
  useSectorQuery
} from '../data/sector-details';

import { Table } from "../components/ui/table";
//import Pagination from '../components/ui/pagination';
import { Pagination, Select } from "antd";
import { t } from "i18next";
import { amount_format, APP_URL, APP_NAME } from "../components/config/Common";
import Breadcrumb  from "../components/Breadcrumb";
import IndicesTable  from "../components/IndicesTable";
import {ArrowNext}  from "../components/icons/arrow-next";
import Seo from 'components/seo/seo'
import { FaExternalLinkAlt } from "react-icons/fa";
import { GoLinkExternal } from "react-icons/go";
import { BsSearch } from "react-icons/bs";
import RelatedScreens from './related-screens/related-screens'

const Sectors = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
	const {slug} = useParams()
	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [metaTitle, setMetaTitle] = useState('NSE/BSE Stock Market Sectors')
	const [metaDesc, setMetaDesc] = useState('Discover NSE/BSE Stock market sectors and explore their details on our platform.')
	const [user_type, setUser_type] = useState('');
  const [snipetData, setSnipetData] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [orderBy, setOrder] = useState('created_at');
  const [sortedBy, setColumn] = useState('desc');
  
  // SORTING
  const [sortInfo, setSortInfo] = useState({ key: null, order: null });
  const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    const [searchQuery, setSearchQuery] = useState(null);
  /* useEffect(() => {
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    console.log("status_p",status_p);
  
  }, [parameters]); */

  const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }
    
  
	//console.log("slug",slug);
	const {
		sectors,
    tree,
    paginatorInfo,
		isLoading,
		error,
	} = useSectorQuery({ 
    slug,
    limit: pageSize,
    page,    
    orderBy,
    sortedBy,
    search:searchQuery,
	});

  
	
const searchForum = (val) => {
      //console.log('sq---', val)
      setSearchQuery(val)
    }


const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Sectors`,
    link:null
  }
]

const SectorNode = ({ item, level = 0 }) => {
  const [open, setOpen] = useState(false);
  const hasChildren = item.children && item.children.length > 0;


  return (
    
    <li>
      <div
        className="flex items-center gap-2 px-3 py-1.5 rounded-md cursor-pointer
                   hover:bg-gray-100 transition"
        style={{ paddingLeft: `${level * 20 + 12}px` }}
        onClick={() => hasChildren && setOpen(!open)}
      >
        <span className="text-gray-800 text-sm font-medium">
          {item.name}
        </span>
        {hasChildren ? (
          <ArrowNext
            size={16}
            className={`text-gray-500 transition-transform
              ${open ? "rotate-90" : ""}`}
          />
          
        ) : (
          <span className="w-4" />
        )}
        <Link className="text-accent" target="_blank" to={`${process.env.REACT_APP_URL}${Links.SECTORS}/${item.slug}`}><GoLinkExternal /></Link>
      </div>

      {hasChildren && open && (
        <ul className="ml-1">
          {item.children.map((child) => (
            <SectorNode
              key={child.id}
              item={child}
              level={level + 1}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

	return (
		<>
    <Seo 
        title={`${metaTitle} - ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/sectors`}
      />
		<Header  />        
        <div className="space-y-5 px-8">
            <Breadcrumb breadcrumb={breadcrumb} />
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">
                <div className="flex flex-col lg:flex-row items-center justify-between">
                  <h2 className="text-2xl">NSE/BSE Stock Market Sectors</h2>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 top-3 flex items-center pl-3 pointer-events-none">
                    <BsSearch className="w-5 h-5 text-gray-400" />
                  </div>
                  <Input 
                    dimension='small' 
                    onChange={(e) => searchForum(e.target.value)} 
                    value={searchQuery}
                    placeholder='Search sector by name...'
                    inputClassName="!px-12"
                  />
                  </div>
                </div>
                

                {/* <div className="mt-4 prose max-w-full" dangerouslySetInnerHTML={{__html: screenDetails?.description || ''}}></div> */}
                
                
                <>
                <IndicesTable 
                    data={sectors} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    pageType={Links.SECTORS}
                />                
                </> 
                {/* <h2 className="text-2xl pt-3">Browse Sectors Tree</h2>              
                <ul className="space-y-1 list-decimal mx-8 my-5">
                  {tree && tree.map((item) => (                    
                    <SectorNode key={item.id} item={item} />
                  ))}
                </ul> */}
    
            </section>
            <RelatedScreens />
        </div>
       
		<Footer />
		
		
		</>
		);
};

export default Sectors;